import React from 'react';
import { Card } from '../ui/Card';
import { ActivityTimeline } from '../shared/ActivityTimeline';
import { PracticeSession } from '../../utils/activityHelpers';
import { History } from 'lucide-react';
interface RecentActivityListProps {
  sessions: PracticeSession[];
}
export function RecentActivityList({
  sessions
}: RecentActivityListProps) {
  return <Card className="p-6" data-id="element-4164">
      <h3 className="text-lg font-bold text-slate-900 mb-6 flex items-center gap-2" data-id="element-4165">
        <History className="w-5 h-5 text-indigo-500" data-id="element-4166" />
        Recente Oefensessies
      </h3>
      <ActivityTimeline sessions={sessions} emptyMessage="Nog geen oefensessies gevonden." data-id="element-4167" />
    </Card>;
}